import { useTranslation } from 'react-i18next'
import type { AnalysisSubTab } from './types'

const ACTIVE_CLASS =
  'px-4 py-2 text-sm font-medium font-[var(--font-mono)] uppercase tracking-wider transition-colors border-b-2 border-[var(--accent)] text-[var(--accent)] bg-[var(--accent-dim)]'

const INACTIVE_CLASS =
  'px-4 py-2 text-sm font-medium font-[var(--font-mono)] uppercase tracking-wider transition-colors text-[var(--text-muted)] hover:text-[var(--text-primary)]'

interface AnalysisTabBarProps {
  activeTab: AnalysisSubTab
  onTabChange: (tab: AnalysisSubTab) => void
}

export function AnalysisTabBar({
  activeTab,
  onTabChange,
}: AnalysisTabBarProps): React.ReactElement {
  const { t } = useTranslation('analysis')

  const tabDefs: Array<{ id: AnalysisSubTab; label: string }> = [
    { id: 'hypotheses', label: t('tabs.hypotheses') },
    { id: 'briefingBoard', label: t('tabs.briefingBoard') },
    { id: 'canvas', label: t('tabs.canvas') },
    { id: 'aiWorkbench', label: t('tabs.aiWorkbench') },
    { id: 'bookmarks', label: t('tabs.bookmarks') },
    { id: 'skillsScripts', label: t('tabs.skillsScripts') },
  ]

  return (
    <div role="tablist" className="flex gap-1 border-b border-[var(--border)]">
      {tabDefs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => {
            onTabChange(tab.id)
          }}
          className={activeTab === tab.id ? ACTIVE_CLASS : INACTIVE_CLASS}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
